import React, { useState, useEffect } from "react";
import { Tag, Calendar, AlertCircle } from "lucide-react";
//import { getCostumerCoupons } from "../../server/Coupon";
import { useSelector } from "react-redux";

const CostumerCoupons = () => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.user.user);

  /*
  useEffect(() => {
    getCostumerCoupons(user.Id)
      .then((res) => {
        setCoupons(res.filter((c) => c.EmailAddress === user.Email));
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  }, []);
  */

  return (
    <div className="details-window">
      <div className="header-window">
        <h2>הקופונים שלי</h2>
      </div>

      <div className="coupons-container">
        {loading ? (
          <div className="loading-message">טוען קופונים...</div>
        ) : coupons.length === 0 ? (
          <div className="empty-message">
            <AlertCircle size={48} />
            <p>אין קופונים זמינים כרגע</p>
          </div>
        ) : (
          <div className="coupons-list">
            {coupons.map((coupon) => (
              <div
                key={coupon.Id}
                className={`coupon-card ${!coupon.Active ? "inactive" : ""}`}
              >
                <div className="coupon-header">
                  <div className="coupon-badge">
                    <Tag size={20} color="#fff" />
                    <span className="discount-text">{coupon.Sum} ₪</span>
                  </div>
                  <div className="coupon-status">
                    {coupon.Active ? (
                      <span className="status-active">פעיל</span>
                    ) : (
                      <span className="status-inactive">פג תוקף</span>
                    )}
                  </div>
                </div>

                <div className="coupon-body">
                  <div className="coupon-code">{coupon.CouponCode}</div>
                  <span className="coupon-description">
                    {" "}
                    למימוש החל מ-{coupon.MinOrder} ₪
                  </span>
                </div>

                <div className="coupon-footer">
                  <Calendar size={16} color="#6b7280" />
                  <span className="expiry-text">
                    תוקף עד:{" "}
                    {new Date(coupon.ExpiredDate).toLocaleDateString("he-IL")}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CostumerCoupons;
